import { omit } from '@helpers/data';

import { WithdrawalsDeleteLimitReducer } from './types';

export const withdrawalsDeleteLimitReducer: WithdrawalsDeleteLimitReducer = (
  state,
  action
) => {
  const { id } = action.payload;

  return {
    ...state,
    withdrawalsLimitsProcessedItems: omit(
      state.withdrawalsLimitsProcessedItems,
      id
    ),
  };
};
